/**
 * reCAPTCHA v3 (invisible) for the portal — Oct 2026.
 * Site key (public) comes from admin-panel/.env: REACT_APP_RECAPTCHA_SITE_KEY=...  (restart npm start / rebuild after
 * changing it). Logins: the check runs in the browser. Sign-up: the token is also checked by the server
 * (registerAccount, secret RECAPTCHA_SECRET_KEY) so robots cannot create accounts.
 * No key set → returns null and the portal works as before (useful on a test computer).
 */
const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';
let loading = null;

function loadScript() {
  if (!SITE_KEY) return Promise.resolve(null);
  if (window.grecaptcha && window.grecaptcha.execute) return Promise.resolve(window.grecaptcha);
  if (!loading) {
    loading = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(SITE_KEY)}`;
      s.async = true;
      s.onload = () => window.grecaptcha.ready(() => resolve(window.grecaptcha));
      s.onerror = () => { loading = null; reject(new Error('The security check (reCAPTCHA) could not load. Check your connection and refresh the page.')); };
      document.head.appendChild(s);
    });
  }
  return loading;
}

/** Load early (when a login / sign-up screen opens) so the check is instant on submit. */
export function preloadRecaptcha() {
  loadScript().catch(() => {});
}

/** Token for one action ('login', 'advertiser_login', 'signup'); null when no site key is configured. */
export async function getRecaptchaToken(action) {
  const g = await loadScript();
  if (!g) return null;
  return g.execute(SITE_KEY, { action });
}
